module.exports = __webpack_public_path__ + "img/logo-lmh-rr.cc3030b8.jpg";